import React from 'react';
import {
  Grid,
  TextField
} from "@material-ui/core";

export default function OverrideDetails({ asset }) {
  return (
    <Grid item xs={12} align="left">
      <Grid item xs={12} >
        <TextField
          id="override-yea"
          label="Override Year"
          value={asset.override_year || "No Year"}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      <Grid item xs={12} >
        <TextField
          id="override-category"
          label="Override Category"
          value={asset.pd_override_category || ""}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="override_make"
          label="Override Make"
          value={asset.override_make || ""}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="override_model"
          label="Override Model"
          value={asset.override_model || ""}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="override_description"
          label="Override Description"
          value={asset.override_description || "No Description"}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="override_condition"
          label="Override Condition"
          value={asset.override_condition || ""}
          type="text"
          margin="normal"
          disabled
        />
      </Grid>
      {
        asset?.type.includes("Truck") &&
        <Grid item xs={12}>
          <TextField
            id="override_mileage"
            label="Override Mileage"
            value={asset?.override_mileage || "No Mileage"}
            type="text"
            margin="normal"
            disabled
          />
        </Grid>
      }
      {
        asset?.type.includes("Trailer") &&
        <Grid item xs={12}>
          <TextField
            id="override-hours"
            label="Override Hours"
            value={asset?.override_hours || "No Override Hours"}
            type="text"
            margin="normal"
            disabled
          />
        </Grid>
      }
    </Grid>
  )
}
